













































import Vue, {VueConstructor} from 'vue'
import UiSwitch from '@/components/Ui/Switch/switch.vue'

export default (Vue as VueConstructor<Vue & {
  $copyText: (text: string) => void
}>).extend({
  components: {
    UiSwitch
  },
  data () {
    return {
      popupVisible: true
    }
  },
  computed: {
  },
  methods: {
  },
  async mounted () {
  }
})
